import { render, staticRenderFns } from "./DashboardTopKeywordsCard.vue?vue&type=template&id=06c5b46e"
import script from "./DashboardTopKeywordsCard.vue?vue&type=script&lang=js"
export * from "./DashboardTopKeywordsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports